<template>
    <div :class="['status_button_component', !showButton ? 'noButton': '']">
        <button class="button-primary  button-status" @click="statusBtnHandler()" v-if="showButton">
            <DotFlashing v-if="statusLoading"/>
            <p v-else class="status_text">
                <span>{{ $t(`${this.buttonProperties.text}`) }}</span>
                <span class="seasonNum" v-if="this.buttonProperties.text === 'RESUME'">
                    <span v-if="currentContent.seasonnum">S {{ currentContent.seasonnum }} E {{ currentContent.episodenum }}</span>
                </span>
            </p>
            <div v-if="playerPositionPerecentage != undefined" class="gray-line"></div>
            <div
                v-if="playerPositionPerecentage"
                class="progress-percent"
                :style="{ width: playerPositionPerecentage + '%' }"
            ></div>
        </button>
        <ChannelAccessDialog v-if="isLiveContentAccessError" :message="getUnsubscribedMessage(errorChannel || currentContent)" @close="closePopup" />

        <PinModal id="pc-pin-detail-modal-player-config" :open="showPinModal" @onClose="closePinModal" :mode="pinMode"
        @onActionComplete="onPinModalActionComplete" :pinError="pinModalError"
        :callbackParentalLockFlag="callbackParentalLockFlag" :loading="pinModalLoading"
        @onForgotPin="openForgotPinModal" />

        <ForgotPinModal id="pc-forgot-pin-modal" :open="showForgotPinModal" @onClose="closeForgotPinModal"
        @onActionComplete="onForgotPinModalActionComplete" :pinError="forgotPinModalError" @onResend="resendOtp"
        :loading="loading" />
    </div>
</template>
<script>
    import Utility from "@/mixins/Utility.js";
    import Redirection from "@/mixins/redirection.js";
    import { eventBus } from "@/eventBus";
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import { store } from "@/store/store";
    import { getDatabase, ref, onValue, get } from "firebase/database";
    import { showSnackBar } from "@/utilities";

    export default {
        props: ['parentData','availabilitiesData'],  
        watch: {
            $route(to, from) {
                this.mainContentData = this.parentData;
            },
            availabilitiesData(newVal, oldVal) {
                if (Array.isArray(newVal) && newVal.length > 0) {
                    this.availabilities = newVal;
                }
            },
            subscriptionList(newVal, oldVal) {
                if (Array.isArray(newVal) && newVal.length > 0) {
                    this.subscriptions = newVal;
                }
            },
            purchaseList(val) {
                this.purchaseListData = val;
            },
            parentData(newVal, oldVal){
                this.mainContentData = newVal;
                this.checkDataStatus();
            }
        },
        components: {
            ChannelAccessDialog: () => import("@/components/Popups/ChannelAccessDialog.vue"),
            ForgotPinModal: () => import("@/components/utils/ForgotPinModal.vue"),
            PinModal: () => import(/* webpackChunkName: "PinModal" */  "@/components/utils/PinModal.vue"),
            DotFlashing: () => import(/* webpackChunkName: "dotFlashing" */ "@/components/Loaders/DotFlashing.vue"),
        },
        computed: {
            ...mapGetters([
                "appConfig",
                "subscriberid",
                "availabilityList",
                "subscriptionList",
                "purchaseList",
                "profileid",
                "getAvailabilityListTotalcount"
            ]),
        },
        created() {
            this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
            this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;
            this.mainContentData = this.parentData;
            this.userInfoDetails = localStorage.getItem("subscriberDetails") ? JSON.parse(localStorage.getItem("subscriberDetails")).data : [];
            this.parentalControlsEnabled = localStorage.getItem("parentalControlEnabled") == 'true' ? true : false;
            eventBus.$on("check-new-fire-data", async () => {
                await this.checkDataStatus();
            });
        },
        data() {
            return {
                buttonProperties: {
                    status: null,
                    text: ""
                },
                userInfoDetails: [],
                subscriptions: [],
                purchaseListData: [],
                availabilities: [],
                mainContentData: null,
                watchedTime: null,
                playerPositionPerecentage: null,
                currentContent: null,
                localDisplayLang: null,
                isLiveContentAccessError: false,
                errorChannel: null,
                watchedEpisodeButton: "",
                pinModalLoading: false,
                showPinModal: false,
                pinModalError: "error message",
                pinMode: "restrict",
                pinModalLoading: false,
                parentalControlsEnabled: false,
                showButton: true,
                statusLoading: true,
            }
        },
        mounted() {
            this.mainContentData = this.parentData;
            this.$nextTick(async ()=> {
                await this.checkDataStatus();
            })
        },
        methods: {
            ...mapMutations(["setRegActiveDeeplink", "setAudioAndSubtitleLangState", "setActivePlaylist"]),
            ...mapActions([
            "getLanguagesByCodes",
            "parentalControlVerifyOldPin",
            "authorizeCurrentStreamApi",
            "setCurrentStreamApi",
            "parentalControlPinSet",
            "parentalControlResetPin",
            "availabilityDetail",
            "subscriberPlaybackExpiry"
            ]),
            async checkPriceModelStatus(contentItem, contentAvailability, packageDetails) {
                if (contentAvailability.pricemodel == 'FREE') {
                    return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'PLAY', isEligible: true }
                } else if ((contentAvailability.pricemodel == "RENTAL" || contentAvailability.pricemodel == "PAID")) {
                    this.isARentalContent = true;
                    if (this.rentPurchasedActive) {
                        return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'PLAY', isEligible: true }
                    } else {
                        let res = await this.availabilityDetail(contentAvailability.availabilityid);
                        let userCountryCurrency = this.userInfoDetails.subscribercountry == 'IN' ? 'INR' : 'USD';
                        let currentPriceItem = {};
                        for (let Item of res.data.priceclassdetail) {
                            if (Item.currency == userCountryCurrency) {
                                currentPriceItem = Item;
                            }
                        }
                        this.rentNowPriceModel = {};
                        this.rentNowPriceModel.planname = this.contentDetails.title;
                        this.rentNowPriceModel.amount = currentPriceItem.price;
                        this.rentNowPriceModel.planid = currentPriceItem.priceclassid;
                        this.rentNowPriceModel.priceclassid = currentPriceItem.priceclassid;
                        this.rentNowPriceModel.availabilityid = contentAvailability.availabilityid;
                        this.rentNowPriceModel.planinterval = res.data.licenseduration;
                        this.rentNowPriceModel.currency = currentPriceItem.currency;
                        this.rentNowPriceModel.rental = "PURCHASE";
                        this.rentNowPriceModel.getPoster = this.getPoster();
                        this.rentNowPriceModel.objectid = this.contentDetails.objectid
                        let buttonStatus = contentAvailability.pricemodel == "RENTAL" ? "RENT NOW" : "PURCHASE NOW";
                        return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: buttonStatus, isEligible: false }
                    }
                } else if (contentAvailability.pricemodel === "PLAN") {
                    this.subscriptions = JSON.parse(localStorage.getItem("subscriptionDetails"));
                    if (this.subscriberid && this.subscriptions?.length > 0) {
                        let isMatched = false;
                        this.subscriptions?.every((subscription) => {
                            // Check if next billing date is greater than today's date.
                            if (this.getDateForPlayback(subscription.nextbilling) &&
                                (this.getDateForPlayback(subscription.nextbilling) <
                                    this.getTodaysDate())
                            ) {
                                isMatched = { buttonStatus: "SUBSCRIBE & WATCH", isEligible: false };
                                return false;
                            } else {
                                let getValue = subscription?.availabilityset?.includes(contentAvailability.availabilityid);
                                if (getValue) {
                                    isMatched = { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'PLAY', isEligible: true }
                                    return false;
                                } else {
                                    isMatched = { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: 'SUBSCRIBE & WATCH', isEligible: false }
                                    return true;
                                }
                            }
                        });
                        return isMatched;
                    } else if (this.subscriberid && this.subscriptions?.length === 0) {
                        return { pricemodel: contentAvailability.pricemodel, availabilityid: contentAvailability.availabilityid, buttonStatus: "SUBSCRIBE & WATCH", isEligible: false }
                    }
                }
            },
            async getPlayBackAvailabilityStatus(contentItem) {
                    if (this.availabilities?.length <= 0) {
                        this.availabilities = localStorage.getItem("availabilityList") ? JSON.parse(localStorage.getItem("availabilityList")) : null;
                    }
                    let { filteredAvailabilityList, packageDetails } = await this.determineContentPackageAvailabilityDetails(contentItem, this.availabilities);
                    // console.log('filteredAvailabilityList, packageDetails', filteredAvailabilityList, packageDetails)
                    if (filteredAvailabilityList?.length <= 0) {
                        this.statusLoading = false;
                        this.showButton = false;
                        this.buttonProperties.status = null;
                        this.buttonProperties.text = "";
                    }
                    let contentPriceModeAvailability = [];
                    const fetchAvailabilityStatus = async () => {
                        const promises = filteredAvailabilityList?.map(async (contentAvailability, i) => {
                            let statusContent = await this.checkPriceModelStatus(contentItem, contentAvailability, packageDetails);
                            return statusContent;
                        });

                        contentPriceModeAvailability = await Promise?.all(promises);
                        // console.log(contentPriceModeAvailability, "contentPriceModeAvailability");
                        let finalDecisionMade = false;
                        contentPriceModeAvailability?.forEach((item) => {
                            if (!finalDecisionMade && item.isEligible) {
                                // If an eligible availability is found, set the button status and stop further checks
                                contentItem.playback_details = {
                                    packageid: packageDetails?.[0]?.packageid,
                                    availabilityid: item?.availabilityid,
                                    drmscheme: packageDetails?.[0]?.drmscheme?.[0],
                                    drmprovider: packageDetails?.[0]?.drmprovider,
                                    streamtype: packageDetails?.[0]?.streamtype,
                                };
                                if (packageDetails?.[0]?.streamurl) {
                                    contentItem.streamUrl = packageDetails?.[0]?.streamurl;
                                }
                                contentItem.videoType = "Content";
                                contentItem.isDrmContent = packageDetails?.[0]?.streamtype === 'NONE' ? true : false;
                                this.buttonProperties.status = item.buttonStatus;
                                finalDecisionMade = true;
                            } else if (!finalDecisionMade && !item.isEligible) {
                                // If no eligible availability is found, but there's an ineligible one, set the button status accordingly
                                contentItem.playback_details = {
                                    packageid: packageDetails.packageid,
                                    availabilityid: item.availabilityid,
                                    drmscheme: packageDetails.drmscheme ? packageDetails.drmscheme[0] : null,
                                    drmprovider: packageDetails?.[0]?.drmprovider,
                                    streamtype: packageDetails?.[0]?.streamtype,
                                };
                                if (packageDetails?.[0]?.streamurl) {
                                    contentItem.streamUrl = packageDetails?.[0]?.streamurl;
                                }
                                contentItem.videoType = "Content";
                                contentItem.isDrmContent = this.isDrmFree ? true : false;
                                this.buttonProperties.status = item.buttonStatus;
                                this.buttonProperties.text = "SUBSCRIBE & WATCH";
                            }
                        });
                    };
                    await fetchAvailabilityStatus();
                    this.statusLoading = false;
                    if(this.watchedTime > 0 && this.buttonProperties.status == "PLAY") {
                        this.buttonProperties.text = "RESUME";
                    } else if(!this.watchedTime && this.buttonProperties.status == "PLAY") {
                        this.buttonProperties.text = "WATCH NOW";
                    }
                // final disition
            },
            async getContentProgress(content) {
                this.playerPositionPerecentage = null;
                const path = `/subscriber/${this.subscriberid}/${this.profileid}/content/${content.objectid}`;
                try {
                    const db = getDatabase();
                    const snapshot = await get(ref(db, path));
                    return snapshot.exists() ? snapshot.val() : null;
                } catch (error) {
                    console.error("Error fetching content progress:", error);
                    throw error;
                }
            },
            async checkDataStatus() {
                if(this.mainContentData.objectstatus == 'PRELAUNCH'){
                    this.statusLoading = false;
                    this.buttonProperties.status = "PRELAUNCH";
                    this.buttonProperties.text = "COMING SOON";
                    return;
                }
                if (this.subscriberid) {
                    if(this.mainContentData.objecttype === "CHANEL" || this.mainContentData.objecttype === "EPGPROGRAMME") {
                        this.currentContent = {...this.mainContentData}
                        await this.getPlayBackAvailabilityStatus(this.currentContent);
                        return;
                    };
                    try {
                        const data = await this.getContentProgress(this.mainContentData);
                        if (data && data.status === "INPROGRESS") {
                            if (data.objecttype === "CONTENT") {
                                const duration = this.mainContentData.duration;
                                this.watchedTime = data.watchedduration;
                                let Perecentage = (data.watchedduration / duration) * 100;
                                console.log("Perecentage", Perecentage)
                                this.playerPositionPerecentage = Perecentage > 0 && Perecentage < 100 ? Perecentage : null;
                                this.currentContent = this.mainContentData;
                                this.currentContent.watchedduration = this.watchedTime;
                            }
                        } else if (data?.episodes) {
                            const allSortEpi = Object.values(data.episodes).sort(
                                (a, b) => b.updatedat - a.updatedat
                            );
                            let continueData = allSortEpi[0];
                            let payload = {
                                contentid: continueData.objectid,
                                params: {
                                    displaylanguage: this.localDisplayLang,
                                },
                            };
                            let episopdeData = await store.dispatch("contentDetail", payload);
                            const duration = episopdeData?.data?.duration;
                            this.watchedTime = continueData.watchedduration;
                            let Perecentage = (continueData.watchedduration / duration) * 100;
                            this.playerPositionPerecentage = Perecentage > 0 && Perecentage < 100 ? Perecentage : null;
                            if(!episopdeData?.errorcode) {
                                this.currentContent = episopdeData.data;
                                this.currentContent.watchedduration = this.watchedTime;
                            };
                        } else {
                            if(this.mainContentData.category === "MOVIE") {
                                this.currentContent = this.mainContentData;
                            } else if(this.mainContentData.objecttype === "SERIES" || this.mainContentData.objecttype === "SHOWS") {
                                // this.getSeasonCount();
                                let seasonPayload = {
                                    objecttype: "SEASON",
                                    seriesid: this.mainContentData.objectid,
                                    pagesize: '1',
                                    page: '1',
                                };
                                let seasonsData = await store.dispatch("listContent", seasonPayload);
                                if(!seasonsData.reason) {
                                    let seasonNum = seasonsData?.data?.data?.[0]?.['seasonnum'];
                                    let episodePayload = {
                                        objecttype: "CONTENT",
                                        seriesid: this.mainContentData.objectid,
                                        seasonnum: seasonNum,
                                        pagesize: 1,
                                        page: 1,
                                        displaylanguage: this.localDisplayLang,
                                    };
                                    let episodeData = await store.dispatch("listContent", episodePayload);
                                    if(episodeData?.data?.reason) {
                                        this.statusLoading = false;
                                        this.showButton = false;
                                    } else {
                                        this.currentContent = episodeData?.data?.data?.[0];
                                    }
                                } else {
                                    this.statusLoading = false;
                                    this.showButton = false;
                                }
                            }
                        }
                    } catch (error) {
                        console.log("error", error);
                    }
                    console.log("after getContentProgress", this.currentContent)
                    await this.getPlayBackAvailabilityStatus(this.currentContent);
                } else {
                    this.statusLoading = false;
                    this.buttonProperties.status = "LOGIN",
                    this.buttonProperties.text = "LOGIN & WATCH";
                }
            },
            closePopup() {
                this.isLiveContentAccessError = false;
                this.errorChannel = null;
            },
            async statusBtnHandler(status=false) {
                if(this.buttonProperties.status === "PRELAUNCH") {
                    // this.watchTrailer();
                } else if (this.buttonProperties.status === "PLAY" || this.buttonProperties.status === "RESUME") {
                    this.playContent();
                } else if (this.buttonProperties.status === "LOGIN") {
                    this.redirectToLogin(this.localDisplayLang);
                } else if(this.buttonProperties.status === "SUBSCRIBE & WATCH") {
                    if (this.isFootballChannel(this.currentContent)) {
                        this.isLiveContentAccessError = true;
                        return;
                    }
                    if(this.subscriberid !== this.profileid) {
                        eventBus.$emit("showAuthorizeErrorMessage", {
                        state: true,
                        messageData: {
                            title: "Error",
                            message: this.$t(
                            "Sorry! Admin only allowed to the payment. Please contact your Admin"
                            ),
                        },
                        });
                        return;
                    }
                    this.redirectToPlans();
                }
            },
            closePinModal() {
                this.showPinModal = false;
                this.callbackParentalLockFlag = "";
            },
            onPinModalActionComplete(enteredPin) {
                this.pinModalLoading = true;
                let payload = {
                    pin: enteredPin,
                };
                this.parentalControlVerifyOldPin(payload)
                    .then((data) => {
                        this.pinModalLoading = false;
                        if (data.data.reason) {
                            this.pinModalError = this.$t(data.data.reason);
                            return;
                        } else if (data.data.success) {
                            this.playContent(true);
                            this.closePinModal();
                        }
                    })
                    .catch((error) => {
                        // console.log("parentalControlVerifyOldPin error -> ", error);
                    });
            },
            async playContent(status = false) {
                if (this.currentContent?.playbacktype && this.currentContent?.playbacktype == 'LOCATORBASEDPLAYBACK') {
                    this.redirectToLocator(this.currentContent);
                } else if (this.currentContent?.playbacktype === "EXTERNALDEEPLINKURLBASEDPLAYBACK") {
                    this.redirectToExternaldeeplinkurlbasedplayback(this.currentContent);
                    return;
                } else if(!this.isContentPlayableParentalLock(this.getCurrentProfile(), this.currentContent?.pgrating) && !status) {
                    if (this.parentalControlsEnabled) {
                        this.callbackParentalLockFlag = "PLAY";
                        this.showPinModal = true;
                        return;
                    }
                } else {
                    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    let uriData = null;
                    const urlencoded = new URLSearchParams();
                    if (isSafari) {
                        uriData = await this.parseHlsManifest(this.currentContent.streamUrl);
                        if (uriData) {
                            urlencoded.append("keyid", uriData[0]);
                            urlencoded.append("keyiv", uriData[1]);
                        }
                    }
                    urlencoded.append("contentid", this.currentContent.channelid || this.currentContent.objectid);
                    urlencoded.append("ios", isSafari ? true : false);
                    urlencoded.append("seclevel", "SW");
                    let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
                    Promise.all([drmPromise])
                        .then(async ([drmRes]) => {
                        let contentData = {...this.currentContent};
                        if(drmRes?.data?.errorcode) {
                            if (String(drmRes.data.errorcode) === '8882' && this.isFootballChannel({ ...this.currentContent, drmTokenResp: drmRes.data })) {
                                this.errorChannel = { ...this.currentContent, drmTokenResp: drmRes.data };
                                this.isLiveContentAccessError = true;
                            } else {
                                showSnackBar(this.getPlaybackErrorMessage(drmRes.data, this.currentContent), this.$t('DISMISS'));
                            }
                            return;
                        }
                        console.log("contentData--", contentData)
                        contentData['drmTokenResp'] = drmRes.data;
                        eventBus.$emit("live-player-active", contentData);
                        })
                        .catch((err) => {
                        console.log("err", err);
                        });
                }
            }
        },
        mixins: [Utility, Redirection],
    }
</script>
<style lang="scss" scoped>
@import "@/sass/_variables.scss";
.status_button_component {
    max-width: 20rem;
    min-width: min-content;
    width: 12.5rem;
    .button-status {
        width: 100%;
        position: relative;
        font-size: 0.8rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        .status_text {
            display: flex;
            gap: 0.5rem;
            .seasonNum {
                font-size: 0.8rem;
                font-weight: 400;
            }
        }
        .progress-percent {
            position: absolute;
            left: 0%;
            bottom: 0%;
            height: 10%;
            border-bottom-left-radius: 8px;
            background-color:  #FFFFFF;
        }
        .gray-line {
            background-color: rgba(255, 255, 255, 0.4);
            height: 10%;
            left: 0%;
            position: absolute;
            width: 100%;
            bottom: -1%;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
    }
}
.noButton {
    width: 0rem !important;
}
</style>